import { useSite } from "@/context/SiteContext";
import { trackEvent } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export function WhatsAppButton() {
  const { settings } = useSite();
  const number = (settings.whatsapp || "").replace(/[^0-9]/g, "");
  if (!number) return null;
  return (
    <a
      href={`https://wa.me/${number}`}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackEvent("whatsapp_click")}
      className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform duration-300 hover:scale-105"
      data-testid="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
